(function($, Drupal, once) {
  Drupal.behaviors.eventSelect2Labels = {
    attach: function(context, settings) {
      once("custom-select2", "select[multiple]", context).forEach(function(
        selectEl
      ) {
        const $select = $(selectEl).select2({
          minimumResultsForSearch: -1,
          width: "100%",
          closeOnSelect: false
        });

        const id = $select.attr("data-drupal-selector");
        updateLabel($select, id);

        $select.on("select2:close", function() {
          updateLabel($select, id);
        });
        $select.on("select2:select", function(e) {
          updateLabel($select, id);
        });
        $select.on("select2:unselect", function(e) {
          updateLabel($select, id);
        });
      });

      function updateLabel($select, id) {
        const count = $select.select2("data").length;
        const $selector = $('[data-select-id="' + id + '"]');
        const label = $selector.attr("data-label-value");
        const placeholder = $selector.attr("data-placeholder-value");

        const html =
          count === 0 && placeholder
            ? `<li>${placeholder}</li>`
            : label
            ? `<li>${label} <strong>${count}</strong></li>`
            : `<li>Selected <strong>(${count})</strong></li>`;

        $select
          .next("span.select2")
          .find("ul")
          .html(html);
      }
    }
  };
})(jQuery, Drupal, once);
